export const CART_ADD_ITEM = "CART_ADD_ITEM";
export const CART_REMOVE_ITEM = "CART_REMOVE_ITEM";
export const CART_SAVE_SHIPPING_ADRESSE = "CART_SAVE_SHIPPING_ADRESSE";
export const CART_SAVE_PAYMENT = "CART_SAVE_PAYMENT";
export const SAVE_SHIPPING_COST = "SAVE_SHIPPING_COST";
export const SAVE_SHIPPING_RATES = "SAVE_SHIPPING_RATES";

export const CART_FETCH_REQUEST = "CART_FETCH_REQUEST";
export const CART_FETCH_SUCCESS = "CART_FETCH_SUCCESS";
export const CART_FETCH_FAIL = "CART_FETCH_FAIL";


export const CART_CLEAR_ITEMS = "CART_CLEAR_ITEMS";
